export default __webpack_public_path__ + "static/media/Category-Gross-Motor-transparent.633db1dc.png";